module.exports = __webpack_public_path__ + "images/157_320.jpg";